/* import __COLOCATED_TEMPLATE__ from './date-filter-block.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();